export async function getQuestion(id) {
  try {
    const data = await fetch('/api/common/question?id=' + id).then(res => res.json());
    return {questions: data.payload, category: data.category};
  } catch (error) {
    return null
  }
}



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QuestionView/actions.js